// extracted by mini-css-extract-plugin
module.exports = {"serviceWrapper":"styles_serviceWrapper__py4DJ","container":"styles_container__HFCTh"};